// 3rd-party modules
import { message } from "antd";
import { useEffect, useState } from "react";
import moment from "moment-timezone";


// project modules
import Button from "../button";
import ConfirmationPopup from "../popup/confirmationPopup";
import InfoPopup from "../popup/infoPopup";
import DataTable, { TableColumn } from "../list/dataTable";
import Loader from "../loader";
import Select from "../inputs/select";
import { CONSTANTS } from "../../../helpers/defines";

import ScheduleModal from "./ScheduleModal";

type tableDataHours = {
  id: string,
  data: string,
  sortParameter: number,
  color: string;
};

type tableData = {
  day: string,
  dayKey: string,
  hours: tableDataHours[]
};



export type ScheduleModel = {
  id?: string;
  fromAmPm?: string;
  fromDay?: string;
  fromHour?: string;
  fromMinute?: string;
  toAmPm?: string;
  toDay?: string;
  toHour?: string;
  toMinute?: string;
  activeDays?: string;
  enabled?: string;
  repeats?: string;
};



type Props = {
  schedules?: ScheduleModel[];
  onChange?: (schedules:ScheduleModel[]) => void;
  hoursLabel?: string;
  newLabel?: string
};


export default function Schedules({ schedules=[], onChange= (s:ScheduleModel[]) => { return ; }, hoursLabel="Blocked Hours", newLabel="New" }: Props) {

  const [schedulesWithId, setSchedulesWithId] = useState<ScheduleModel[]>([])
  const [datasource, setDatasource] = useState<any[]>([]);
  const [currentSchedule, setCurrentSchedule] = useState<ScheduleModel|null>(null)
  const [deleteConfirmationPopupOpen, setDeleteConfirmationPopupOpen] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [reload, setReload] = useState(false)


   


  useEffect(() => {
    /*
    let customData: tableData[] = [
      {
        day: 'Monday',
        dayKey: 'mon',
        hours: []
      },
      {
        day: 'Tuesday',
        dayKey: 'tue',
        hours: []
      },
      {
        day: 'Wednesday',
        dayKey: 'wed',
        hours: []
      },
      {
        day: 'Thursday',
        dayKey: 'thu',
        hours: []
      },
      {
        day: 'Friday',
        dayKey: 'fri',
        hours: []
      },
      {
        day: 'Saturday',
        dayKey: 'sat',
        hours: []
      },
      {
        day: 'Sunday',
        dayKey: 'sun',
        hours: []
      }
    ]
    */
    let newIds:any = []
    let swid:any = []
    for (let index = 0; index < schedules.length; index++) {
      let s = { ...schedules[index] }; //clones object
      if(s.id == null) {
        s.id = getUnusedId(newIds);
        newIds.push(s.id)
      }
      swid.push(s)

      /*
      customData.forEach(item => {
        if (s.activeDays?.includes(item.dayKey)) {
          item.hours.push({
            id: s.id!,
            data: `${ getFromTime(s) } - ${ getToTime(s) }`,
            sortParameter: (s.fromHour ? parseInt(s.fromHour) : 0) * 100 + ( s.fromMinute ? parseInt(s.fromMinute) : 0),
            color: CONSTANTS.COLOR_SEQUENCE[index % CONSTANTS.COLOR_SEQUENCE.length]
          })
        }
      });
      */
    }
    setSchedulesWithId(swid);
    updateDatasource(swid);

  }, []);

   useEffect(() => {
    if (reload) {
      setReload(false);
    }
  }, [reload]);

  const updateDatasource = (swid:any) => {

    swid = !!swid ? swid : schedulesWithId;

    let customData: tableData[] = [
      {
        day: 'Monday',
        dayKey: 'mon',
        hours: []
      },
      {
        day: 'Tuesday',
        dayKey: 'tue',
        hours: []
      },
      {
        day: 'Wednesday',
        dayKey: 'wed',
        hours: []
      },
      {
        day: 'Thursday',
        dayKey: 'thu',
        hours: []
      },
      {
        day: 'Friday',
        dayKey: 'fri',
        hours: []
      },
      {
        day: 'Saturday',
        dayKey: 'sat',
        hours: []
      },
      {
        day: 'Sunday',
        dayKey: 'sun',
        hours: []
      }
    ]
    for (let index = 0; index < swid.length; index++) {
      let s = swid[index]; 

      customData.forEach(item => {
        if (s.activeDays?.includes(item.dayKey)) {
          item.hours.push({
            id: s.id!,
            data: `${ getFromTime(s) } - ${ getToTime(s) }`,
            sortParameter: (s.fromHour ? parseInt(s.fromHour) : 0) * 100 + ( s.fromMinute ? parseInt(s.fromMinute) : 0),
            color: CONSTANTS.COLOR_SEQUENCE[index % CONSTANTS.COLOR_SEQUENCE.length]
          })
        }


      });
    }
    setDatasource(customData);

  };



  const getUnusedId = (invalidIds = []) => {
    let newId = 1;
    let found = true;
    while(found) {
      found = false;
      for(let sid=0; sid < schedules.length; sid++) { 
        found = found || ( schedules[sid].id != null && schedules[sid].id == ("@NEW--" + newId) )
      }
      for(let sid=0; sid < schedulesWithId.length; sid++) { 
        found = found || ( schedulesWithId[sid].id != null && schedulesWithId[sid].id == ("@NEW--" + newId) )
      }
      for(let sid=0; sid < invalidIds.length; sid++) { 
        found = found || ( invalidIds[sid] == ("@NEW--" + newId) )
      }

      if(found) { 
        newId = newId+1;
      }
    }

    return "@NEW--" + newId;
  }

  const getFromTime = (schedule: ScheduleModel) => {
    let fromTime = schedule.fromHour && schedule.fromMinute && schedule.fromAmPm ? `${schedule.fromHour}:${schedule.fromMinute} ${schedule.fromAmPm}`: null;
    return fromTime;
  }
  const getToTime = (schedule: ScheduleModel) => {
    let toTime = schedule.toHour && schedule.toMinute && schedule.toAmPm ? `${schedule.toHour}:${schedule.toMinute} ${schedule.toAmPm}`: null;
    return toTime;

  }

  const onScheduleSave = (schedule: ScheduleModel) => {
    let newSchedules = schedulesWithId.filter( (s:ScheduleModel) => s.id != schedule.id )
    newSchedules.push(schedule)
    setSchedulesWithId([...newSchedules])
    updateDatasource(newSchedules)
    onChange([...newSchedules])
    setReload(true)
  }




  const onEditClick = (schedule: ScheduleModel) => {
    setCurrentSchedule(schedule);
    setShowScheduleModal(true);
  };

  const onNewClick = () => {

    let newModel:ScheduleModel = { }
    newModel.id = getUnusedId()
    setCurrentSchedule(newModel);

    setShowScheduleModal(true);
    
  };

  const onDeleteClick = (schedule: ScheduleModel) => {
    setCurrentSchedule(schedule);
    setDeleteConfirmationPopupOpen(true);
  };




  const handleDeleteRequest = async () => {
    let newSchedules = schedulesWithId.filter( (s:ScheduleModel) => currentSchedule == null || s.id != currentSchedule.id )

    setSchedulesWithId([...newSchedules])
    updateDatasource(newSchedules)

    onChange([...newSchedules])
    setDeleteConfirmationPopupOpen(false);

    setReload(true)

  };

  const columns: TableColumn<any>[] = [
    {
      title: () => <text data-weight="600" data-space="10">Week Days</text>,
      key: 'day',
      width: 120,
      render: (text,record: tableData) => <text data-weight="600" data-space="10">{record.day}</text>
    },
    {
      title: <text data-weight="600" data-space="10">{ hoursLabel }</text>,
      key: '',
      render: (_, record: tableData) =>
        <group data-gap="5">
          {
            record.hours.sort((a: any, b: any) => b.sortParameter - a.sortParameter).map(hour =>
              <group key={hour.id} data-color={hour.color} data-background="" data-width="auto" data-align="center" data-wrap="no" data-border="outline" data-radius="5" data-contain="" onClick={() => onEditClick(schedulesWithId.find(x => x.id === hour.id)!)}>
                <div className="button" data-shrink="no" data-radius="0" effect="material"><text data-weight="400">{hour.data}</text></div>
                <separator vertical=""></separator>
                <div className="button micro" data-radius="0" effect="material" onClick={(e: any) => { e.stopPropagation(); onDeleteClick(schedulesWithId.find(x => x.id === hour.id)!) }}><icon data-color="black">clear</icon></div>
              </group>
            )
          }
        </group>
    },
  ];

  return (
    <>
      <group className="table_cont" data-background="none" >
        <group data-space="15" data-gap="20" data-border="" data-background="highlight">
          <Button
            material
            icon="add"
            text={newLabel}
            primary
            onClick={onNewClick}
          />
        </group>
        <DataTable
          columns={columns}
          bordered={true}
          dataSource={datasource}
          rowKey={record => `${record.dayKey}`}
          size="small"
          pagination={false}
          customPageSize={ 999999999 }
          reload={reload}
        />
      </group>
      {!!showScheduleModal &&
        <ScheduleModal
          schedule={currentSchedule}
          closeOnSave={true}
          onClose={() => setShowScheduleModal(false)}
          onSave={(e) => onScheduleSave(e)} />
      }
      {deleteConfirmationPopupOpen && (
        <ConfirmationPopup
          showButton={false}
          positiveButtonText="Delete"
          positiveCallback={handleDeleteRequest}
          negativeCallback={() => {
            setDeleteConfirmationPopupOpen(false);
          }}
        />
      )}
    </>
  );
}
